import { Controller } from "@hotwired/stimulus"

// Glass-nav on scroll + close mobile menu on nav click
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this._onScroll = this._handleScroll.bind(this)
    window.addEventListener("scroll", this._onScroll, { passive: true })
    this._handleScroll() // initial check
  }

  disconnect() {
    window.removeEventListener("scroll", this._onScroll)
  }

  _handleScroll() {
    const scrollY = window.scrollY
    this.element.classList.toggle("scrolled", scrollY > 60)
  }

  // Close mobile menu when a nav link is clicked
  closeMenu() {
    const menu = this.menuTarget
    const toggle = this.element.querySelector(".navbar-toggler")
    if (menu && menu.classList.contains("show")) {
      toggle?.click()
    }
  }
}
